import "./dropDown.css";

const AgreementDropDownSelector = ({
  headerText,
  agreements,
  agreementId,
  setAgreementId,
}) => {
  function handleChange(evt) {
    setAgreementId(evt.target.value);
  }

  return (
    <div className="admin-dropdown-container">
      <label className="admin-dropdown-label">{headerText}</label>
      <select
        onChange={handleChange}
        value={agreementId}
        className="admin-dropdown"
        disabled={!agreements?.length}
      >
        <option value="NA"> -- Alla -- </option>
        {agreements.map((a, index) => (
          <option key={index} value={a.AgreementId}>
            {a.AgreementName} - {a.AgreementId}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AgreementDropDownSelector;
